import { useTranslation } from 'react-i18next';

import { SidePanelSectionTabSt } from '~organisms/SidePanelSectionTab';

interface RemoveApplianceModalProps {
  title?: string;
  description?: string;
  isOpen: boolean;
  onClose: () => void;
}

const RemoveApplianceModal = ({
  title,
  description,
  isOpen,
  onClose,
}: RemoveApplianceModalProps) => {
  const { t } = useTranslation();

  return (
    <SidePanelSectionTabSt.RemoveOptionModal
      open={isOpen}
      onCancel={onClose}
      footer={
        <SidePanelSectionTabSt.RemoveOptionModalCloseBtn onClick={onClose}>
          {t('COMMON.CLOSE')}
        </SidePanelSectionTabSt.RemoveOptionModalCloseBtn>
      }
    >
      <SidePanelSectionTabSt.RemoveOptionModalTitle>
        {title ||
          t('DESIGN_TOOLBAR.REMOVE_MODAL.TITLE', {
            option: t('COMMON.APPLIANCE'),
          })}
      </SidePanelSectionTabSt.RemoveOptionModalTitle>
      <SidePanelSectionTabSt.RemoveOptionModalDescription>
        {description || t('DESIGN_TOOLBAR.REMOVE_MODAL.APPLIANCE')}
      </SidePanelSectionTabSt.RemoveOptionModalDescription>
    </SidePanelSectionTabSt.RemoveOptionModal>
  );
};

export default RemoveApplianceModal;
